export default __webpack_public_path__ + "static/media/speaking_girl.38da15c4.png";